import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { UiActions, UiState } from './types'

const initialState: UiState = {
  footerActionBarCount: 0,
}

/**
 * Cross-cutting chrome state read outside the router tree. `<AppToaster/>` is
 * mounted above `RouterProvider` and cannot see the route, so the screen that
 * owns a sticky footer registers it here instead (#1516 anomaly 10).
 */
export const useUiStore = create<UiState & UiActions>()(
  devtools((set) => ({
    ...initialState,

    addFooterActionBar: () => {
      set((state) => ({ footerActionBarCount: state.footerActionBarCount + 1 }))
    },

    removeFooterActionBar: () => {
      // Clamped: a stuck-open bar only wastes 72px, a stuck-closed one gives
      // the click back to the toast.
      set((state) => ({
        footerActionBarCount: Math.max(0, state.footerActionBarCount - 1),
      }))
    },
  }))
)

/** True while any screen shows a footer action bar toasts must clear. */
export const selectIsFooterActionBarOpen = (state: UiState) =>
  state.footerActionBarCount > 0
